import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col, Button, Tooltip } from 'antd';
import Translate, { translate } from 'react-translate-component';
import { pick, head } from 'ramda';

import { openModalMassStage, openModalEventCreate } from 'actions/modalActions';
import { getWorksheetMassList, getUser } from 'actions/asyncActions';
import CustomIcon from 'components/common/CustomIcon';

const LicenseTooltip = ({ mapLicense, children }) => !mapLicense ? (
    <Tooltip title={translate('worksheetMass.mass_license')}>
        {children}
    </Tooltip>
) : children;

const stateToProps = (state, props) => ({
    data: getWorksheetMassList
        .withParams(pick(['id', 'stage'], props.params))
        .selectData(state),
    mapLicense: getUser.selectData(state).MAPLicense,
});

@connect(stateToProps, { openModalMassStage, openModalEventCreate })
export default class WorksheetMassListButtons extends Component {
    static propTypes = {
        data: PropTypes.object,
        params: PropTypes.object,
        selected: PropTypes.array,
        openModalMassStage: PropTypes.func,
        openModalEventCreate: PropTypes.func,
        projectId: PropTypes.number,
        mapLicense: PropTypes.bool,
    };

    createEvent = () => {
        const { data, selected, openModalEventCreate } = this.props;

        const project = head(data.position);
        const person = {
            id: head(selected)
        };

        openModalEventCreate({
            project,
            person,
            participators: data.responsible
        });
    }

    openChangeStageModal = () => {
        const { selected, openModalMassStage, projectId } = this.props;

        openModalMassStage({
            projectId,
            keyList: selected.map(id => ({ id }))
        });
    }

    getButton = () => {
        const { selected, mapLicense } = this.props;

        return (
            <Button
                disabled={!selected.length || !mapLicense}
                onClick={this.openChangeStageModal}
            >
                <CustomIcon type='user-with-arrow' />
                <Translate component='span' content='worksheetMass.changeStage' />
            </Button>
        )
    }

    render() {
        const { mapLicense, selected } = this.props;

        const disabledCreate = selected.length !== 1 || !mapLicense;

        return (
            <Row className='m-b-15'>
                <Col>
                    <LicenseTooltip mapLicense={mapLicense}>
                        <Button disabled={disabledCreate} onClick={this.createEvent}>
                            <CustomIcon type='calendar-plus' />
                            <Translate component='span' content='worksheet.create' />
                        </Button>
                    </LicenseTooltip>
                    <LicenseTooltip mapLicense={mapLicense}>
                        {this.getButton()}
                    </LicenseTooltip>
                </Col>
            </Row>
        );
    }
}
